import { render, staticRenderFns } from "./MarketPlaceDashboard.vue?vue&type=template&id=07da610e&scoped=true"
import script from "./MarketPlaceDashboard.vue?vue&type=script&lang=js"
export * from "./MarketPlaceDashboard.vue?vue&type=script&lang=js"
import style0 from "./MarketPlaceDashboard.vue?vue&type=style&index=0&id=07da610e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07da610e",
  null
  
)

export default component.exports